import { useContext } from 'react';

import { GoalProgressContext } from './goal-progress-context';

export const useOpenGoalProgressAddEntry = () => {
  const { onOpenGoalProgressAddEntry } = useContext(GoalProgressContext);

  return onOpenGoalProgressAddEntry;
};
